import React from "react";
import { uploadDocument } from "../firebase/storage";
import TitleBar from "../components/TitleBar";
import RaisedButton from "../components/RaisedButton";
import InnerBody from "../components/InnerBody";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import withAuthorization from "../firebase/withAuthorization";
import DocumentsPanel from "../components/DocumentsPanel";
import FlatButton from "../components/FlatButton";
import {
  getProject,
  deleteDocument,
  getProjectUpdates,
  getClientUpdates,
  commitProjectToClient
} from "../firebase/firestore";
import Dialog from "../components/Dialog";
import Viewer from "react-viewer";
import "react-viewer/dist/index.css";
import withAccount from "../utils/withAccount";
import StatusBadge from "../components/StatusBadge";

class PageManageProject extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      clientId: this.props.match.params.clientId,
      projectId: "",
      clients: [],
      files: [],
      filesInQueue: 0,
      deleteDialogVisible: false,
      deleteDialogDocId: "",
      projectData: { name: "" },
      completeDialogVisible: false
    };

    this.projectsListenerUnsub = false;
    this.clientListenerUnsub = false;
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    if (this.projectsListenerUnsub) this.projectsListenerUnsub();
    if (this.clientListenerUnsub) this.clientListenerUnsub();
  }

  fetchData() {
    const { clientId } = this.state;
    const { account } = this.props;
    const { projectId } = this.props.match.params;

    getProject(
      account.id,
      projectId,
      doc => {
        if (doc.exists) {
          if (doc.data().client !== clientId) {
            this.props.history.replace(`/dash/projects/${clientId}`);
            return;
          }

          this.setState({
            isLoading: false,
            projectId: projectId,
            projectData: doc.data()
          });
        } else {
          this.props.history.replace(`/dash/projects/${clientId}`);
        }
      },
      error => {
        this.props.history.replace(`/dash/projects/${clientId}`);
      }
    );

    this.projectsListenerUnsub = getProjectUpdates(
      account.id,
      projectId,
      docs => {
        let files = [];

        docs.forEach(element => {
          let data = element.data();
          files.push({
            id: element.id,
            name: data.name,
            type: data.type,
            url: data.url
          });
        });

        this.setState({ files: files });
      }
    );

    this.clientListenerUnsub = getClientUpdates(account.id, docs => {
      let clients = [];

      docs.forEach(element => {
        let data = element.data();
        clients.push({ id: element.id, name: data.name, status: "" });
      });

      this.setState({ clients: clients });
    });
  }

  addFiles(e) {
    e = e.target;
    if (e.files === undefined || e.files === null || e.files.length <= 0)
      return;

    const { account } = this.props;

    let filesAdded = 0;
    for (let i = 0; i < e.files.length; i++) {
      const file = e.files[i];

      const supportedMimeTypes = [
        "image/jpeg",
        "image/png",
        "image/svg+xml",
        "image/tiff",
        "image/gif",
        "image/webp"
      ];

      if (supportedMimeTypes.indexOf(file.type) > -1) {
        uploadDocument(
          account.id,
          file,
          this.state.projectId,
          (snap, url, doc) => {
            this.setState({
              filesInQueue: this.state.filesInQueue - 1
            });
          }
        );
        filesAdded++;
      } else {
        alert(`Der Dateityp von ${file.name} wird nicht unterstützt.`);
      }
    }
    this.setState({ filesInQueue: this.state.filesInQueue + filesAdded });
  }

  confirmDocumentDeletion(docId) {
    const { projectData } = this.state;
    const status = projectData.status;
    if (status !== 0) return;

    this.setState({ deleteDialogVisible: true, deleteDialogDocId: docId });
  }

  deleteDocument() {
    const { account } = this.props;
    const projectId = this.state.projectId;
    const docId = this.state.deleteDialogDocId;

    deleteDocument(account.id, projectId, docId, () => {}, error => {});

    this.setState({ deleteDialogVisible: false });
  }

  viewPage(url, page) {
    this.setState({ viewerVisible: true, viewerSrc: url });
  }

  commitProject() {
    const { account } = this.props;
    const { clientId, projectId } = this.state;

    commitProjectToClient(
      account.id,
      clientId,
      projectId,
      () => {
        this.props.history.replace(`/dash/projects/${clientId}`);
      },
      err => {
        console.error(err);
      }
    );
  }

  render() {
    const { projectData, clients } = this.state;
    const status = projectData.status;
    const editable = status === 0;

    return (
      <div>
        <Header
          title={projectData.name}
          showProjectsDropdown={true}
          clientChangeable={false}
          selectedClientId={this.state.clientId}
          showProfile={true}
          clients={clients}
        />
        <NavigationSideBar page="projects" />
        <InnerBody isLoading={this.state.isLoading}>
          <TitleBar title="Dokumente">
            {editable ? (
              <RaisedButton
                label="Dokument hinzufügen"
                onClick={() => this.upload.click()}
              />
            ) : (
              <StatusBadge status={status} />
            )}
          </TitleBar>
          <DocumentsPanel
            editable={editable}
            viewPage={(url, page) => this.viewPage(url, page)}
            onDocumentDelete={id => this.confirmDocumentDeletion(id)}
            filesInQueue={this.state.filesInQueue}
            files={this.state.files}
          />
          <TitleBar
            title={
              <FlatButton
                label="Zur Übersicht"
                onClick={() => this.props.history.goBack()}
              />
            }
          >
            {this.state.files.length > 0 && editable ? (
              <RaisedButton
                label="Fertigstellen"
                onClick={() => {
                  this.setState({ completeDialogVisible: true });
                }}
              />
            ) : null}
          </TitleBar>
        </InnerBody>

        <Viewer
          visible={this.state.viewerVisible}
          onClose={() => {
            this.setState({ viewerVisible: false });
          }}
          onMaskClick={() => {
            this.setState({ viewerVisible: false });
          }}
          images={[{ src: this.state.viewerSrc, alt: "" }]}
          scalable={false}
          drag={true}
          downloadable={true}
          noNavbar={true}
          noImgDetails={true}
          changeable={false}
          zoomSpeed={0.1}
        />
        <input
          id="myInput"
          type="file"
          multiple
          accept="image/*,application/pdf"
          ref={ref => (this.upload = ref)}
          style={{ display: "none" }}
          onChange={e => this.addFiles(e)}
        />
        <Dialog
          title="Dokument Fertigstellen"
          action="Fertigstellen"
          visible={this.state.completeDialogVisible}
          onAccept={() => this.commitProject()}
          onClose={() => this.setState({ completeDialogVisible: false })}
        >
          Möchten Sie dieses Projekt wirklich fertigstellen?
          <br />
          <br />
          Folgendes wird passieren:
          <br />
          1. Das Projekt kann von Ihnen nicht mehr bearbeitet werden.
          <br />
          2. Der Kunde, der mit diesem Projekt verknüpft ist, bekommt eine
          E-Mail mit einem Link zum Freigabecenter.
          <br />
          3. Nach dem das Projekt vom Kunden bearbeitet wurde, werden Sie
          darüber benachrichtigt.
          <br />
        </Dialog>
        <Dialog
          title="Dokument Löschen"
          action="Löschen"
          theme="bad"
          visible={this.state.deleteDialogVisible}
          onAccept={() => this.deleteDocument()}
          onClose={() => this.setState({ deleteDialogVisible: false })}
        >
          Möchtest du dieses Dokument wirklich löschen? Diese Aktion ist
          permanent und kann nicht rückgängig gemacht werden!
        </Dialog>
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(withAccount(PageManageProject));



// WEBPACK FOOTER //
// ./src/pages/PageManageProject.js